import { render, staticRenderFns } from "./ConfirmationInfoModal.vue?vue&type=template&id=157ec1a2"
import script from "./ConfirmationInfoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationInfoModal.vue?vue&type=style&index=0&id=157ec1a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports